module.exports = __webpack_public_path__ + "static/media/greater-than-equal.b14fe8fe.svg";